<template>
  <div class="content__column content__column--small" v-if="group">
    <h1 class="content__title">Editar Grupo de galerías</h1>
    <form class="form" @submit.prevent="saveGroup">
      <div class="fom__fieldset">
        <div class="form__container">
          <label for="name" class="form__label form__label--required">Nombre del grupo de galerías</label>
          <input type="text" class="form__input" name="name" id="name" v-model="group.name" v-validate="validation.name">
          <span v-show="errors.has('name')" class="form__alert" v-text="errors.first('name')"></span>
        </div>
      </div>
      <input type="submit" class="btn btn__action btn--regular" value="Guardar">
      <button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">Agregar Nuevo Grupo</button>
    </form>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
export default {
  props: {
    group: {
      type: Object,
      required: false,
      default: function () {
        return {
          id: null,
          name: null
        }
      }
    }
  },
  mixins: [
    httpService
  ],
  data: function () {
    return {
      validation: {
        name: 'required|max:50'
      }
    }
  },
  methods: {
    saveGroup: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'gallery_groups',
                element: this.group
              }
              let action
              if (this.group.id) {
                action = this.put(this.group.id, httpRequest)
              } else {
                action = this.post(httpRequest)
              }
              action.then(
                response => {
                  if (!this.group.id) {
                    this.group.id = response.data.current_id
                  }
                  this.$store.commit('elementChanged', {
                    module: 'galleryGroupEdit',
                    time: Math.round((new Date()).getTime() / 1000)
                  })
                  this.$store.commit('notificate', {
                    title: 'GRUPO GUARDADO',
                    text: 'El grupo de galerías ha sido guardado correctamente',
                    type: 'success'
                  })
                }
              ).catch(
                () => {
                  this.$store.commit('notificate', {
                    title: 'GRUPO NO GUARDADO',
                    text: 'El grupo de galerías no ha sido guardado, por favor, intente más tarde',
                    type: 'error'
                  })
                }
              )
            }
          }
        )
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_forms"
</style>


// WEBPACK FOOTER //
// src/components/gallery_groups/edit.vue